const mia = "/_app/immutable/assets/mia.CrJbd0lR.png";
export {
  mia as default
};
